import { render, staticRenderFns } from "./CardLikeButton.vue?vue&type=template&id=821c73fa"
import script from "./CardLikeButton.vue?vue&type=script&lang=ts"
export * from "./CardLikeButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports